import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function QuotationStyles(params = {}) {
    const { MobileBreakpoint, palette } = params;

    return {
        "& .quotation": {
            "& .quotation-avatar": {
                width: "134px",
                height: "134px",
                padding: "24px",
                justifySelf: "center",
                alignSelf: "flex-start",
                borderRadius: "67px",
                background: "center / cover no-repeat",
                backgroundColor: palette.primary.initial,
                filter: "drop-shadow(1px 1px 0 #ffffff) drop-shadow(1px -1px 0 #ffffff) drop-shadow(-1px 1px 0 #ffffff) drop-shadow(-1px -1px 0 #ffffff)",

                [MobileBreakpoint]: {
                    width: "65px",
                    height: "65px",
                },
            },

            "& .quotation-content": {
                // alignSelf: "end",
            },

            "& .quotation-text": {
                fontSize: "24px",
                fontWeight: "700",
                [MobileBreakpoint]: {
                    fontSize: "14px",
                },
            },

            "& .quotation-author": {
                fontSize: "14px",
                fontWeight: "600",
                padding: "24px 0",
                [MobileBreakpoint]: {
                    fontSize: "10px",
                },
            },

            // ----------Variant 1----------
            "&.variant-1": {
                display: "grid",
                gridGap: "50px",
                maxWidth: "550px",
                padding: "40px",

                "& .quotation-text": {
                    textAlign: "center",
                },

                "& .quotation-author": {
                    textAlign: "center",
                },

                "&.reverse": {
                    gridAutoFlow: "dense",
                },

                [MobileBreakpoint]: {
                    gridGap: "20px",
                    padding: 0,
                },
            },

            // ----------Variant 2----------
            "&.variant-2": {
                display: "grid",
                gridAutoFlow: "column",
                gridGap: "30px",
                padding: "20px 0",
                // maxWidth: "900px",

                "& .quotation-text": {
                    textAlign: "left",
                },

                "& .quotation-author": {
                    textAlign: "left",
                },

                "&.reverse": {
                    "& .quotation-avatar": {
                        order: 2,
                    },
                },

                [MobileBreakpoint]: {
                    gridAutoFlow: "row",
                    padding: "0",

                    "& .quotation-text": {
                        textAlign: "center",
                    },

                    "& .quotation-author": {
                        textAlign: "center",
                    },

                    "& .quotation-avatar": {
                        order: "0 !important",
                    },
                },
            },

            [MobileBreakpoint]: {},
        },
    };
}

export default function Quotation(props) {
    const LI = useLoremIpsum();
    let { name, feedback, picture, variant, reverse } = props;

    const style = {};
    if (picture) {
        style.backgroundImage = `url(${picture.retina || picture.src})`;
    } else {
        style.display = "none";
    }

    const elProps = toElementProps(props, { className: ["quotation", `variant-${variant}`, reverse ? "reverse" : ""] });
    return (
        <div {...elProps}>
            <div className="quotation-avatar" style={style} />

            <div className="quotation-content">
                <div className="quotation-text">{feedback || LI.Feedbacks[0].feedback}</div>
                <div className="quotation-author">{name || LI.Feedbacks[0].name}</div>
            </div>
        </div>
    );
}
